import { post } from "../../service/api";

const PaidChecker = async (secureId) => {
    try {
        const response = await post(`/invoice/bySecureId/${secureId}/checkLowCost`);
        return response;
    } catch (error) {
        console.error('Error PaidChecker:', error);
        throw error;
    }
};

export default PaidChecker;